import styled from 'styled-components';

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: ${({visible}) => (visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  overflow: auto;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 10000000;
`;

export default Container;
